import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './mutations'
import actions from './actions'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    fingerprint: null,
    clientType: null,
    appVersion: process.env.PACKAGE_VERSION || 0,
    webView: false,
    mapOptions: null,
    account: null,
    loadingProgress: {
      upload: 0,
      download: 0
    },
    offline: false,
    available: false
  },
  mutations,
  actions,
  getters
})
